/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import SourceAccount from "app/shared/components/source-account/source-account";
import i18n from "app/shared/language/i18n";
import { Constant } from "app/shared/constant/constant";
import FormTransferForeign from "./form-transfer-foreign/form-transfer-foreign";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { useDispatch, useSelector } from "react-redux";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { ACCOUNT } from "app/shared/services/services-model.type";
import ScreenNameType from "@navigation/nav-screens";
import { getTransferForeignStoreSelector } from "../reducer/selectors";
import { fetchTransferForeignCreateRequest, fetchTransferForeignMakeFeeRequest, setTransferForeignReset } from "../reducer/actions";
import { DataTransferCreate } from "../../reducer/types";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import StackParamsList from "app/navigation/nav-stack-params";
import { getBeneStoreSelector } from "app/modules/beneficiaries/reducer/selectors";
import { setBeneStore } from "app/modules/beneficiaries/reducer/actions";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.TRANS_FOREIGN>;

const TransferForeign = () => {
  const dispatchStore = useDispatch();
  const { dispatch, navigate } = useNavigation();

  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("TRANFER_CHUYEN_TIEN"),
      onPressSubtitle: () => {
        eventPushCleverTap(undefined, undefined, "cancel");
        dispatch(StackActions.replace(ScreenNameType.LIST_TRANSFER));
      },
    },
    {
      name: t("TRANFER_CHUYEN_TIEN_NGOAI_PVCOMBANK"),
      onPressSubtitle: () => {},
    },
  ];

  const routeProps = useRoute<ProfileScreenRouteProp>();
  const transferForeignStore = useSelector(getTransferForeignStoreSelector);
  const beneStore = useSelector(getBeneStoreSelector);
  const contactId = useSelector(getContactIdSelector);

  const [globalModalRef] = useState<React.RefObject<any>>(createGlobalModal());
  const [accountDebit, setAccountDebit] = useState<ACCOUNT>({});
  const [isValidAccount, setIsValidAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const onCancel = () => {
    eventPushCleverTap(undefined, undefined, "cancel");
    dispatch(StackActions.replace(ScreenNameType.LIST_TRANSFER));
  };

  // Submit Khởi tạo
  const onSubmit = () => {
    setIsSubmit(true);
  };

  const onChangeAccountDebit = (account: ACCOUNT, isValid: boolean) => {
    setAccountDebit(account);
    setIsValidAccount(isValid);
  };

  const requestMakeFee = (data: DataTransferCreate) => {
    if (accountDebit.ACCOUNTNO?.length && isValidAccount) {
      data.ACCOUNT_DEBIT = accountDebit;
      dispatchStore(fetchTransferForeignMakeFeeRequest(data));
    }
  };

  const requestCreate = (data: DataTransferCreate) => {
    if (accountDebit.ACCOUNTNO?.length && isValidAccount) {
      data.ACCOUNT_DEBIT = accountDebit;
      dispatchStore(fetchTransferForeignCreateRequest(data));
    }
  };

  const closeModal = () => {
    globalModal.hide(globalModalRef);
  };

  const showModal = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };

  const eventPushCleverTap = (status?: boolean, response?: string, action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response, action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string, action?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_transfer_type: "the_other_bank",
      ct_account_type: transferForeignStore.dataCreate?.TYPE === Constant.TRANSFER.TRANSFER_247_TYPE.CRD ? "ATM card number" : "Account number", // Account number | ATM card number
      ct_beneficiary_bank: transferForeignStore.dataCreate?.BANK?.value,
      ct_transfer_amount: transferForeignStore.dataCreate?.AMOUNT,
      ct_transfer_content: transferForeignStore.dataCreate?.DESCRIPTION,
      ct_transfer_charged: transferForeignStore.dataCreate?.FEE_TYPE === Constant.TRANSFER.TRANSFER_FEE_TYPE.I ? "receiver" : "transferor", // receiver | transferor
      ct_button: action || "", // account_detail |fee_detail | beneficiary | continue | cancel
      ct_error_message: status === false ? response || "" : "",
    };

    if (status !== undefined) {
      param = {
        ...param,
        ct_transfer_create_status: status ? "success" : "failure",
      };
    }
    return {
      eventNameCT: "ct_transfer_create",
      paramsCT: param,
    };
  };

  useEffect(() => {
    console.log("Khởi tạo");
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setTransferForeignReset());
      dispatchStore(setBeneStore({ ...beneStore, addSuccess: false, addProfile: undefined, pending: false }));
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  useEffect(() => {
    if (isSubmit) setIsSubmit(false);
  }, [isSubmit]);

  useEffect(() => {
    if (transferForeignStore.statusFee === "error") {
      eventPushCleverTap(false, transferForeignStore.errorMsg, "fee_detail");
    } else if (transferForeignStore.statusFee === "ok") {
      eventPushCleverTap(true, undefined, "fee_detail");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferForeignStore.statusFee]);

  useEffect(() => {
    if (transferForeignStore.statusCreate === "error") {
      eventPushCleverTap(false, transferForeignStore.errorMsg, "continue");
    } else if (transferForeignStore.statusCreate === "ok") {
      eventPushCleverTap(true, undefined, "continue");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferForeignStore.statusCreate]);

  useEffect(() => {
    if (transferForeignStore.isCreated) {
      navigate(ScreenNameType.TRANS_FOREIGN_CONFIRM);
    }
  }, [navigate, transferForeignStore.isCreated]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={i18n.t("TRANFER_CHUYEN_TIEN_NGOAI_PVCOMBANK")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <StepProcessUniversal currentSteps={0} />
          <SourceAccount
            onChangeAccount={onChangeAccountDebit}
            type={[Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT]}
            isSubmit={isSubmit}
            account={accountDebit}
          />
          <FormTransferForeign
            accountDebit={accountDebit}
            onSubmit={onSubmit}
            onCancel={onCancel}
            requestCreate={requestCreate}
            requestMakeFee={requestMakeFee}
            showModal={showModal}
            closeModal={closeModal}
          />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default TransferForeign;
